import { render, staticRenderFns } from "./dvcList.vue?vue&type=template&id=843faf42&scoped=true&%3Ais=view&transition=fade&transition-mode=out-in&"
import script from "./dvcList.vue?vue&type=script&lang=js&"
export * from "./dvcList.vue?vue&type=script&lang=js&"
import style0 from "./dvcList.vue?vue&type=style&index=0&id=843faf42&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "843faf42",
  null
  
)

export default component.exports